import React from 'react'

const TittleModule = ({ title }) => (
  <div
    className="w-[98%] lg:h-20 h-10 flex items-center bg-black lg:text-3xl text-white rounded-xl px-4 mb-4 mx-auto shadow-md relative"
  >
    <span>
      {title}
    </span>
  </div>
)

const ModuleLayout = ({tittle, children}) => {
  return (
    <div className="w-full pb-2 flex flex-col items-center">
      <TittleModule title={tittle} />
      <div className={`bg-white rounded-xl shadow-md h-[80vh] w-full -mt-16 transition-all duration-300 ease-in-out overflow-auto shadow-gray-600 pt-16`}>
        <div className="h-full w-full pb-2 flex flex-col items-center">
          {children}
        </div>
      </div>
    </div>
  )
}

export default ModuleLayout